import logo from "../assests/images/logo.png";
import menuIcon from "../assests/images/menu.png";
import cartIcon from "../assests/images/cart.png";
import searchIcon from "../assests/images/search.png";
import banner1 from "../assests/images/banner1.png";
import banner3 from "../assests/images/banner3.png";
import banner5 from "../assests/images/banner5.png";
import homebackground from "../assests/images/banner2.png";
import pickdesignbutton from "../assests/images/pickdesignbutton.png";
import pickcategory from "../assests/images/pickcategory.png";
import demoPLP from "../assests/images/demoPLP.jpg";
import demoPDP from "../assests/images/demoPDP.jpg";
import aboveImage from "../assests/images/aboveImage.png"; // Example image
import behindImage from "../assests/images/behindImage.png"; // Example image
import modelImage from "../assests/images/modelImage.png"; // Example image
import quantityImage from "../assests/images/quantityImage.png"; // Example image
import buyNowImage from "../assests/images/buyNowImage.png"; // Example image
import titlep1 from "../assests/images/titlep1.png"; // Example image
import titlep2 from "../assests/images/titlep2.png"; // Example image
import bodyp1 from "../assests/images/bodyp1.png"; // Example image
import bodyp2 from "../assests/images/bodyp2.png"; // Example image
import minititlep2 from "../assests/images/minititlep2.png"; // Example image

import TopSalesProducts from "../assests/images/TopSalesProducts.png"; // Example image
export const images = {
  logo,
  menuIcon,
  cartIcon,
  searchIcon,
  banner1,
  banner5,
  homebackground,
  pickdesignbutton,
  pickcategory,
  demoPLP,
  demoPDP,
  aboveImage,
  behindImage,
  modelImage,
  quantityImage,
  buyNowImage,
  titlep1,
  titlep2,
  bodyp1,
  bodyp2,
  minititlep2,
  TopSalesProducts,
  banner3,
};
